import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { AUTH_BASE_URL } from '../../auth-base-url.token';
import { LoginRequestDto } from '../../schemas/authenticate/login-request.dto';
import { LoginResponseDto } from '../../schemas/authenticate/login-response.dto';
import { CheckSessionResponseDto } from '../../schemas/authenticate/check-session-response.dto';
import { RefreshTokenRequestDto } from '../../schemas/authenticate/refresh-token-request.dto';
import { RefreshTokenResponseDto } from '../../schemas/authenticate/refresh-token-response.dto';
import { ServerDateTimeDto } from '../../schemas/server-datetime.dto';

@Injectable({ providedIn: 'root' })
export class AuthenticateApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(AUTH_BASE_URL)}/authenticate`;

    login(payload: LoginRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/login`)
            .post(payload)
            .json<LoginResponseDto>()
            .build()
            .send();
    }

    checkSession() {
        return this.builder
            .url(`${this.controllerUrl}/checksession`)
            .post(null)
            .json<CheckSessionResponseDto>()
            .build()
            .send();
    }

    refresh(payload: RefreshTokenRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/refresh`)
            .post(payload)
            .json<RefreshTokenResponseDto>()
            .build()
            .send();
    }

    getServerTime() {
        return this.builder
            .url(`${this.controllerUrl}/getservertime`)
            .get()
            .json<ServerDateTimeDto>()
            .build()
            .send();
    }
}
